import { theme, createStyles, makeStyles } from '@forgeglobal/design-framework';

export const useStyles = makeStyles(() =>
  createStyles({
    button: {
      padding: theme.spacing(1.5, 9.2),
    },
    buttonContainer: {
      marginTop: theme.spacing(4),
    },
    requestLink: {
      paddingLeft: theme.spacing(0.5),
    },
    textField: {
      '&.MuiSvgIcon-colorAction, .MuiSvgIcon-colorAction': {
        display: 'none',
      },
    },
    gridItem: {
      '&.MuiGrid-root': {
        paddingTop: theme.spacing(3),
      },
    },
  })
);
